import React from "react";
import { Column, Columns, Modal, Section, Table, Title } from "@allxsmith/bestax-bulma";


export default function InfoModal({show, setShow}){



    // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
    return (
        <Modal
            active={show}
            closeOnBlur
            onClose={()=> setShow(false)}
        >
            <Modal.Content>
                <Section style={{background: "white"}}>
                    <Columns isMultiline>
                        <Column>
                            <Title>Info</Title>
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <Table isBordered>
                                <tr>
                                    <td className={"table-highlight-red"}></td>
                                    <td>If the quote has only finished jobs and not started jobs</td>
                                </tr>
                                <tr>
                                    <td className={"table-highlight-green"}></td>
                                    <td>If the quote is ready for approval (all work items and parts have workshop invoice numbers) and all jobs are approved</td>
                                </tr>
                                <tr>
                                    <td className={"table-highlight-orange"}></td>
                                    <td>If the quote has a job and does not meet any of the other conditions above</td>
                                </tr>
                            </Table>
                        </Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    );

}